import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

import {ColumnGroup} from 'common/components/data-table/types';
import {FunnelQueryResponse} from 'common/report/funnels/models/api-types';
import {FunnelBookmark} from 'common/report/funnels/models/types';
import {getBookmarkWithAppliedDefaults} from 'common/report/funnels/util/bookmark-overrides';

import {StatSigClickHandler} from '../cell-renderers';
import {FunnelStepBookmarkType, FunnelTableRow} from '../types';
import {FunnelsStepProjectDetails, getDataTableInfo, getStepChartData, StepChartData} from '../util';
import {StepChartBookmarkController} from './index';

// TODO once the behavior and metrics project is over we will remove this
export class FunnelsStepChartBookmarkController implements StepChartBookmarkController {
  type = FunnelStepBookmarkType.FUNNELS;
  bookmark: FunnelBookmark;
  queryResults: FunnelQueryResponse;

  constructor(bookmark: FunnelBookmark, results: FunnelQueryResponse) {
    this.bookmark = bookmark;
    this.queryResults = results;
  }

  public getBookmarkWithAppliedDefaults(bookmark: FunnelBookmark): FunnelBookmark {
    return getBookmarkWithAppliedDefaults(bookmark);
  }
  public getStepChartData({projectDetails}: {projectDetails: FunnelsStepProjectDetails}) {
    return getStepChartData(this.bookmark, this.queryResults, projectDetails);
  }

  public getSorting() {
    return this.bookmark.sorting;
  }

  public getDataTableInfo({
    stepChartData,
    projectDetails,
    tableWidth,
    onStatSigClick,
  }: {
    stepChartData: StepChartData;
    projectDetails: FunnelsStepProjectDetails;
    tableWidth: number;
    onStatSigClick: StatSigClickHandler;
  }): {rows: FunnelTableRow[]; columnGroups: ColumnGroup[]; comparisonRows?: FunnelTableRow[]} {
    return getDataTableInfo({
      bookmark: this.bookmark,
      projectDetails,
      onStatSigClick,
      formattedData: stepChartData.funnelSegments,
      formattedCompareData: stepChartData.funnelCompareSegments,
      formattedLiftData: stepChartData.funnelLiftSegments,
      isDownloadMode: false,
      savedLegend: stepChartData.savedLegend,
      tableWidth,
      showStepNamesInGroupHeaders: true,
    });
  }

  public isEmptyReport(): boolean {
    return isEmpty(this.queryResults?.data);
  }

  public isEquivalent(bookmark: any, results: any) {
    return isEqual(this.bookmark, bookmark) && isEqual(this.queryResults, results);
  }

  public getDataGroupId(): string {
    return this.bookmark.data_group_id;
  }

  public getPropSumLabel(): string {
    return ``; // only possible in multi-metric
  }
}
